import { SectionSelectionTableContent } from "src/components/SectionSelectionTableContent";
import { TableSearchProvider } from "src/components/TableSearchContext";

interface SectionSelectionTableProps {
  onPreview: (sectionId: string) => void;
  onImport: (sectionId: string) => void;
  importingSectionId: string | null;
}

const PAGE_SIZE = 10;

export function SectionSelectionTable(props: SectionSelectionTableProps) {
  return (
    <TableSearchProvider defaultPageSize={PAGE_SIZE} backend="state">
      <SectionSelectionTableContent
        onPreview={props.onPreview}
        onImport={props.onImport}
        importingSectionId={props.importingSectionId}
      />
    </TableSearchProvider>
  );
}
